const dateFormat = date => {
  const d = date?.split('-')
  return `${d[2]}-${d[1]}-${d[0]}`
}

export default dateFormat
